import React, { useEffect, useState } from 'react'
import { Button, Col, Container, FormControl, FormGroup, FormLabel, FormSelect, Row } from 'react-bootstrap';
import Menu from '../Componentes/Menu';
import { MenuItems } from '../Componentes/MenuItems';
import { Form, useNavigate } from 'react-router-dom';
import { Dispositivo } from '../Interfaces/Interfaces';
import { registrarDispositivo } from '../Promesas/Promesas';

interface Props{
    setToolbar:(isActive:boolean)=>void;
    hamburguesa:boolean;
    isLogin:boolean;
  }

export const AgregarDispositivo = (props:Props) => {
    const names = ['nombre','estado']
    const inititalState:Dispositivo = {id:'',nombre:'',estado:'encendido'};
    const [dispositivo, setDispositivo] = useState<Dispositivo>(inititalState);
    const [respuesta,setRespuesta] = useState("");
    const navigate = useNavigate()
    useEffect(()=>{
      if(!props.isLogin){
        navigate('/')
      }else{
        props.setToolbar(true);


      }
          
      },[])


      const registrar = ()=>{
        registrarDispositivo(dispositivo).then((id)=>{
            setRespuesta(id);
        });
      }
      const handleChange = (value:string,name:string)=>{
            setDispositivo({...dispositivo,[name]:value})
      }
  return (
    <>
    <Row>
        <Menu key="menu1" menu={props.hamburguesa}>
          <MenuItems/>
        </Menu>
            <Col>
            <Container style={{marginTop:'5px'}}>
            <Form>
                <FormGroup className="mb-3" controlId="nombre">
                    <FormLabel>Nombre</FormLabel>
                    <FormControl type="text" name="nombre" onChange={(e)=>{handleChange(e.target.value,e.target.name)}}/>
                </FormGroup>
                <FormGroup className="mb-3" controlId="password">
                    <FormLabel>Estado</FormLabel>
                    <FormSelect name="estado" onChange={(e)=>{handleChange(e.target.value,e.target.name)}}>
                        <option  value="1">Encendido</option>
                        <option  value="0">Apagado</option>
                    </FormSelect>
                </FormGroup>
                <Button onClick={registrar}>Registrar</Button>
            </Form>
            <div>Dispositivo Creado!</div>
            <div>El id del dispositivo es: {respuesta}</div>
            </Container>
            </Col>
          </Row>
        </>
  )
}
